import React, { useEffect, useRef, useState } from "react";

const Otp = ({ length, onSubmit, onResendOtpCode, isMutation }) => {
  const inputRef = useRef([]);
  const [value, setValue] = useState(new Array(length).fill(""));

  const onChangeHandler = ({ target: { value: inputValue } }, index) => {
    if (isNaN(inputValue)) return;

    const newValue = [...value];
    newValue[index] = inputValue.slice(-1);
    setValue(newValue);

    if (inputValue && index < length - 1) inputRef.current[index + 1].focus();

    const finalValue = newValue.join("");
    finalValue.length === length && onSubmit(finalValue);
  };

  const onClickHandler = (index) => inputRef.current[index].setSelectionRange(1, 1);

  const onKeyDownHandler = (e, index) => {
    if (e.key === "Backspace" && index > 0 && !value[index]) {
      inputRef.current[index - 1].focus();
    }
  };

  const resendOtpCode = () => {
    setValue(new Array(length).fill(""))
    if (inputRef.current[0]) inputRef.current[0].focus();
    onResendOtpCode()
  }

  useEffect(() => {
    if (inputRef.current[0]) inputRef.current[0].focus();
  }, []);

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <div className="rounded-2xl p-8 w-full max-w-md transition-all duration-300">

        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
            Verificación OTP
          </h1>
          <p className="text-gray-500 dark:text-gray-300">
            Ingresa el código de 5 dígitos enviado a tu WhatsApp y correo
          </p>
        </div>

        {/* Loader cuando se está validando el OTP */}
        {isMutation.loginotploading ? (
          <div className="flex flex-col items-center my-6">
            <p className="mb-2 text-blue-600 font-medium">Validando OTP</p>
            <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-500 border-t-transparent"></div>
          </div>
        ) : (
          <form className="flex justify-center gap-3 mb-6">
            {value.map((item, index) => (
              <input
                key={index}
                ref={(input) => (inputRef.current[index] = input)}
                value={item}
                className="w-14 h-14 text-2xl text-center border-2 border-gray-200 dark:border-gray-600 
                rounded-lg focus:outline-none focus:border-blue-500 dark:focus:border-blue-400 
                bg-brand-200 dark:bg-brand-800 text-black dark:text-white transition-colors duration-200"
                placeholder="-"
                onChange={(e) => onChangeHandler(e, index)}
                onClick={() => onClickHandler(index)}
                onKeyDown={(e) => onKeyDownHandler(e, index)}
                inputMode="numeric"
                autoComplete="one-time-code"
              />
            ))}
          </form>
        )}

        <div className="text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-4 flex items-center justify-center gap-2">
            ¿No recibiste el código?{" "}
            {isMutation.resendotploading ? (
              <span className="flex items-center space-x-2 text-blue-500 dark:text-blue-400 animate-pulse text-xs font-normal">
                <span>Reenviando OTP...</span>
                <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              </span>
            ) : (
              <button
                onClick={resendOtpCode}
                className="text-blue-500 hover:text-blue-600 dark:hover:text-blue-400 font-medium transition-colors"
              >
                Reenviar código
              </button>
            )}
          </p>
        </div>
      </div>
    </div>

  );
};

export default Otp;